import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';

import CheckIcon from 'assets/images/icons/check.svg';
import FailIcon from 'assets/images/icons/close.svg';
import HelpIcon from 'assets/images/icons/help-icon.svg';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 5rem 8.5rem;
  background: transparent;
  textarea {
    border: none;
    background: transparent;
    color: #35447d;
    outline: none;
    resize: none;
    width: 100%;
    height: 100%;
    font-size: 1.6rem;
    &::placeholder {
      color: #35447d;
      opacity: 1;
    }
  }
  .limit {
    font-size: 1.2rem;
    margin-top: 5rem;
    margin-left: -8.5rem;

    img { margin-left: 1rem; }
    .help-icon {
      height: 2.7rem;
      width: 2.7rem;
      margin-left: 1.2rem;
    }
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flex--start {
    justify-content: flex-start;
  }
`;

function TextArea({
  help,
  limit,
  value,
  ...rest
}) {
  return (
    <Wrapper>
      <textarea value={value} {...rest} />
      <div className="limit flex flex--start">
        {limit > 0 && limit <= 2000
          ? (
            <div className="flex">
              {limit}<img alt="check-icon" src={CheckIcon} />
            </div>
          )
          : (
            <div className="flex">
              Too many characters<img alt="check-icon" src={FailIcon} />
            </div>
          )
        }
        {help !== '' &&
          <Popup
            inverted
            trigger={<img className="help-icon" alt="help-icon" src={HelpIcon} />}
            position="top center"
            content={help}
          />
        }
      </div>
    </Wrapper>
  );
}

TextArea.propTypes = {
  help: PropTypes.string,
  limit: PropTypes.number,
  value: PropTypes.string,
};

TextArea.defaultProps = {
  help: '',
  limit: 0,
  value: '',
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea/index.js